export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/business_proposal.942e058.svg";